import React, { useState } from 'react';

export const useLayout = () => {
	const [isSidbarCollapsed, setIsSidbarCollapsed] = useState(false);
	return {
		isSidbarCollapsed,
		setIsSidbarCollapsed
	};
};
export const LayoutConteact = React.createContext({
	isSidbarCollapsed: true,
	setIsSidbarCollapsed: () => {}
});
